import { openModal } from 'tradera-state/ui/action-creators';
import { types } from './item-actions-helper';
import purchaseOrderActions from '../state/actions/purchase-order';
import { SINGLE_FEEDBACK_DIALOG_ID } from '../components/leave-feedback/single-feedback-dialog';
import featureToggles from '../utils/feature-toggles';
import myTraderaActions from '../state/actions/my-tradera';

const getId = purchaseOrder => purchaseOrder.purchaseOrderId;

const showModal = translationKey => {
    return myTraderaActions.openModal({
        bulkAction: 'MytListInfo',
        modal: {
            cssClass: 'fixed',
            icon: 'check',
            isSingleButton: true,
            getTranslatedMessage: t => t(translationKey)
        }
    });
};

export const boughtActions = (purchaseOrder, listViewType) => {
    const actions = [
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Begär samfraktpris',
            getTranslatedLabel: t =>
                t('myt_itemCard_actions_request_combinedshipping'),
            dispatch: dispatch => {
                dispatch(
                    purchaseOrderActions.requestCombinedShippingPrice(
                        purchaseOrder.purchaseOrderId,
                        !purchaseOrder.combinedShippingInformation
                            .hasBuyerRequestedCombinedShippingPrice
                    )
                );
            },
            gaLabel: 'RequestCombinedShipping',
            isVisible: () =>
                purchaseOrder.combinedShippingInformation &&
                !purchaseOrder.combinedShippingInformation
                    .hasBuyerRequestedCombinedShippingPrice &&
                !purchaseOrder.shipping.shippingDiscount &&
                !purchaseOrder.state.isPaid,
            isPrimaryAction: () => !purchaseOrder.shipping.shippingDiscount
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Betala',
            getTranslatedLabel: t => t('myt_itemCard_actions_pay'),
            dispatch: dispatch => {
                if (purchaseOrder.state.isPaymentExpired) {
                    return dispatch(showModal('myt_orderinfo_paymentExpired'));
                }
                return (window.location.href = `/Shopping/Checkout/SelectPayment?purchaseOrderId=${purchaseOrder.purchaseOrderId}`);
            },
            gaLabel: 'Pay',
            buttonTheme: 'success',
            isVisible: () => {
                if (purchaseOrder.state.isPaid) {
                    return false;
                }
                if (
                    purchaseOrder.combinedShippingInformation &&
                    purchaseOrder.combinedShippingInformation
                        .hasBuyerRequestedCombinedShippingPrice &&
                    !purchaseOrder.shipping.shippingDiscount
                ) {
                    return false;
                }
                return (
                    !purchaseOrder.state.isPaid &&
                    !purchaseOrder.state.isMarkedAsPaidByBuyer
                );
            },
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Markera som betald',
            getTranslatedLabel: t => t('myt_itemCard_actions_markAsPaid'),
            dispatch: dispatch => {
                if (purchaseOrder.state.isPaymentExpired) {
                    return dispatch(showModal('myt_orderinfo_paymentExpired'));
                }
                if (
                    purchaseOrder.combinedShippingInformation &&
                    !purchaseOrder.shipping.shippingDiscount &&
                    !purchaseOrder.shipping.selectedShipping
                ) {
                    return dispatch(showModal('myt_modal_mark_as_paid_info'));
                }
                dispatch(
                    purchaseOrderActions.updatePurchaseOrderPaidByBuyer(
                        purchaseOrder.purchaseOrderId,
                        listViewType,
                        true
                    )
                );
            },
            gaLabel: 'MarkAsPaid',
            isVisible: () => {
                if (purchaseOrder.state.isPaid) {
                    return false;
                }
                if (
                    !purchaseOrder.combinedShippingInformation &&
                    !purchaseOrder.shipping.selectedShipping &&
                    !purchaseOrder.shipping.shippingDiscount
                ) {
                    return false;
                }
                return (
                    !purchaseOrder.state.isPaidWithIntegratedPayment &&
                    !purchaseOrder.state.isMarkedAsPaidByBuyer
                );
            },
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Avmarkera som betald',
            getTranslatedLabel: t => t('myt_itemCard_actions_unmarkAsPaid'),
            dispatch: dispatch =>
                dispatch(
                    purchaseOrderActions.updatePurchaseOrderPaidByBuyer(
                        purchaseOrder.purchaseOrderId,
                        listViewType,
                        false
                    )
                ),
            gaLabel: 'UnmarkAsPaid',
            isVisible: () => {
                if (purchaseOrder.state.isPaid) {
                    return false;
                }
                return (
                    !purchaseOrder.state.isPaidWithIntegratedPayment &&
                    purchaseOrder.state.isMarkedAsPaidByBuyer &&
                    !purchaseOrder.state.isPaymentExpired
                );
            },
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Lämna omdöme',
            getTranslatedLabel: t => t('myt_itemCard_actions_leaveFeedback'),
            dispatch: dispatch => {
                dispatch(
                    openModal({
                        modalId: SINGLE_FEEDBACK_DIALOG_ID,
                        data: {
                            purchaseOrderId: purchaseOrder.purchaseOrderId,
                            transactionIds: purchaseOrder.itemsToGiveFeedBackTo
                        }
                    })
                );
            },
            gaLabel: 'LeaveFeedbackOnSeller',
            isVisible: () => !!purchaseOrder.itemsToGiveFeedBackTo.length,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.LINK,
            label: 'Orderbekräftelse',
            getTranslatedLabel: t =>
                t('myt_itemCard_actions_orderConfirmation'),
            url: `/Shopping/OrderConfirmation?purchaseOrderId=${purchaseOrder.purchaseOrderId}`,
            gaLabel: 'OrderConfirmation',
            isVisible: () => !featureToggles.isBuyerOrderInformationEnabled,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.LINK,
            label: 'Orderinformation',
            getTranslatedLabel: t => t('myt_itemCard_actions_orderInformation'),
            url: `/my/order/${purchaseOrder.purchaseOrderId}`,
            gaLabel: 'OrderInformation',
            isVisible: () => featureToggles.isBuyerOrderInformationEnabled,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.EXTERNAL_LINK,
            label: 'Spåra paket',
            getTranslatedLabel: t => t('myt_itemCard_actions_trackShipment'),
            url: `${purchaseOrder.shipping.shipping?.url}`,
            gaLabel: 'BuyerTrackShipment',
            isVisible: () =>
                !featureToggles.isBuyerOrderInformationEnabled &&
                !!purchaseOrder.shipping.shipping?.url,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.LINK,
            label: 'Spåra paket',
            getTranslatedLabel: t => t('myt_itemCard_actions_trackShipment'),
            url: `/my/order/${purchaseOrder.purchaseOrderId}#shipping`,
            gaLabel: 'BuyerTrackShipment',
            isVisible: () =>
                featureToggles.isBuyerOrderInformationEnabled &&
                !!purchaseOrder.shipping.shipping?.url,
            isPrimaryAction: () => true
        }),
        () => ({
            // "INR" = "Item Not Received"
            id: getId(purchaseOrder),
            type: types.LINK,
            label: 'Anmäl utebliven leverans',
            getTranslatedLabel: t =>
                t('myt_itemCard_actions_reportFailureToDeliver'),
            url: `/resolution/INR2/${purchaseOrder.purchaseOrderId}`,
            gaLabel: 'ReportItemNotReceived',
            isVisible: () =>
                !purchaseOrder.payment.hasBuyerProtection &&
                !purchaseOrder.state.isInrSubmitted &&
                featureToggles.isInrPurchaseOrderEnabled,
            isPrimaryAction: () => true
        }),
        // () => ({ TODO REWRITE TO REACT
        //     id: getId(item),
        //     type: types.LINK,
        //     label: 'Anmäl utebliven vara',
        //     getTranslatedLabel: t => t('myt_itemCard_actions_createDispute'),
        //     url: `/resolution/disputes/${item.transaction.transactionId}`,
        //     gaLabel: 'CreateDispute',
        //     isVisible: () =>
        //         featureToggles.isDisputesEntranceEnabled &&
        //         item.transaction.hasBuyerProtection &&
        //         !item.transaction.dispute,
        //     isPrimaryAction: () => !item.haveMultipleRows
        // }),
        () => ({
            id: getId(purchaseOrder),
            type: types.LINK,
            label: 'Säljarens annonser',
            getTranslatedLabel: t => t('myt_itemCard_actions_itemsFromSeller'),
            url: `/profile/items/${purchaseOrder.buyerMember.memberId}/${purchaseOrder.buyerMember.alias}`,
            gaLabel: 'SellerOtherItems',
            isVisible: () => true,
            isPrimaryAction: () => true
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Dölj',
            getTranslatedLabel: t => t('myt_itemCard_actions_hide'),
            dispatch: dispatch =>
                dispatch(
                    purchaseOrderActions.updatePurchaseOrderHiddenForBuyer(
                        purchaseOrder.purchaseOrderId,
                        purchaseOrder.transactionIds,
                        true,
                        listViewType
                    )
                ),
            gaLabel: 'HideSold',
            isVisible: () => !purchaseOrder.state.isHiddenForBuyer,
            isPrimaryAction: () => false
        }),
        () => ({
            id: getId(purchaseOrder),
            type: types.DISPATCH,
            label: 'Ångra dölj',
            getTranslatedLabel: t => t('myt_itemCard_actions_unhide'),
            dispatch: dispatch =>
                dispatch(
                    purchaseOrderActions.updatePurchaseOrderHiddenForBuyer(
                        purchaseOrder.purchaseOrderId,
                        purchaseOrder.transactionIds,
                        false,
                        listViewType
                    )
                ),
            gaLabel: 'UnhideSold',
            isVisible: () => purchaseOrder.state.isHiddenForBuyer,
            isPrimaryAction: () => false
        })
    ];

    return actions;
};
